export const UPGRADE_COMPACT_MIN_COLUMN = 128;
export const UPGRADE_COMPACT_CARD_CLASS = '!h-[176px]';
export const UPGRADE_SELECTED_CARD_CLASS = 'ring-2 ring-inset ring-white';
